import { render, staticRenderFns } from "./imgElement.vue?vue&type=template&id=48879810&scoped=true"
import script from "./imgElement.vue?vue&type=script&lang=js"
export * from "./imgElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48879810",
  null
  
)

export default component.exports